import {getGaClientId} from '@optimaxdev/analytics/desktop/lib/clientId/index';
import {createAction, createAsyncThunk, createReducer} from '@reduxjs/toolkit';

import {ENDPOINTS} from 'constants/endpoints';
import {PAYMENTS} from 'desktop/pages/checkout/constants/paymentStep';
import {SaveApplePayExpressType} from 'desktop/types/payPalExpressType';
import {apiConfig, HTTP_REQUEST_HEADER, HTTP_REQUEST_HEADER_CONTENT_TYPE_VALUE} from 'libs/api/api';
import {CompleteOrderType} from 'types/completeOrderType';

export const initialState = {
    loading: false,
};

export const setPayPalExpressLoading = createAction<boolean>('PAYPAL_EXPRESS@SET_LOADING');
export const savePayPalExpress = createAction<SaveApplePayExpressType>('PAYPAL_EXPRESS@SAVE');

export const savePayPalExpressPayment = createAsyncThunk<
    {message: string},
    SaveApplePayExpressType
>('PAYPAL_EXPRESS@SAVE_PAYMENT', paymentInfo => {
    const data = new FormData();

    data.append('payment[method]', PAYMENTS.METHOD_PAYPAL_V3);
    data.append('payment[token]', paymentInfo.token);
    data.append('payment[payment_id]', paymentInfo.id);

    return apiConfig.instanceGusaBackend.request({
        data,
        headers: {
            [HTTP_REQUEST_HEADER.CONTENT_TYPE]:
                HTTP_REQUEST_HEADER_CONTENT_TYPE_VALUE.MULTIPART_FORM_DATA,
        },
        method: 'post',
        url: `${ENDPOINTS.CHECKOUT_SET_PAYMENT}`,
    });
});

/**
 *form data for paypal express order
 */
export const formDataPaypalExpress = (affid: string) => {
    const data = new FormData();

    data.append('subscribe-newsletter', '0');
    data.append('payment[method]', PAYMENTS.METHOD_PAYPAL_V3);
    data.append('payment[walkway]', 'cart');
    data.append('payment[terms]', '1');
    data.append('affid', affid || '');
    data.append('ga_cid', getGaClientId());
    return data;
};

export const savePayPalExpressOrder = createAsyncThunk<CompleteOrderType, string>(
    'PAYPAL_EXPRESS@SAVE_ORDER',
    (affid: string) => {
        const data = formDataPaypalExpress(affid);

        return apiConfig.instanceGusaBackend.request({
            data,
            headers: {
                [HTTP_REQUEST_HEADER.CONTENT_TYPE]:
                    HTTP_REQUEST_HEADER_CONTENT_TYPE_VALUE.MULTIPART_FORM_DATA,
            },
            method: 'post',
            url: `${ENDPOINTS.CHECKOUT_PLACE_ORDER}`,
        });
    },
);

export const payPalExpress = createReducer(initialState, builder =>
    builder.addCase(setPayPalExpressLoading, (state, action) => ({
        ...state,
        loading: action.payload,
    })),
);
